import React from 'react';

export default function EmptyState({ icon, title, body, action }) {
  return (
    <div className="exam-empty exam-empty-state">
      {icon && (
        <div className="exam-empty-icon">{icon}</div>
      )}
      <h3 className="exam-empty-title">{title}</h3>
      {body && <p className="exam-empty-body">{body}</p>}
      {action && <div style={{ marginTop: 8 }}>{action}</div>}
    </div>
  );
}
